<template>
  <div class="manageCert">
    <div style="padding:0px 10px">
      <el-select v-model="value" size="small" placeholder="请选择项目" @change="((val)=>{selectOp(val)})">
        <el-option
          v-for="item in options"
          :key="item.id"
          :label="item.projectName"
          :value="item.id"
          >
        </el-option>
      </el-select>
      <el-select v-model="projectIdVal" size="small" placeholder="请选择类型" @change="((val)=>{selectType(val)})">
        <el-option
          v-for="item in projectIds"
          :key="item.id"
          :label="item.typeName"
          :value="item.id">
        </el-option>
      </el-select>
      <!-- <div style="width:150px;display:inline-block;">
        <el-input v-model="keyWords" size='small ' placeholder="请输入内容"></el-input>
      </div> -->
      <el-button type="primary" size='small ' icon="el-icon-search" @click="pageQueryMemberTeamUserCert()">搜索</el-button>
    </div>
    <div style="padding:0px 10px 40px 10px;position:relative" v-loading="cartLoading" element-loading-text="加载中">
      <el-table
        :data="UserCerts"
        >
          <el-table-column
            width="100"
            label="用户名"
            prop="userName">
          </el-table-column>
          <el-table-column
            width="200"
            label="身份证号"
            prop="idNo">
          </el-table-column>
          <el-table-column
            width="200"
            label="证书号"
            prop="certNo">
          </el-table-column>
          <el-table-column
            width="100"
            label="所属项目"
            prop="projectName">
          </el-table-column>
          <el-table-column
            width="100"
            label="证书类别"
            prop="typeName">
          </el-table-column>
          <el-table-column
            width="150"
            label="获证日期"
            prop="getDate">
            <template slot-scope="scope">
              <span>{{resetTime(scope.row.getDate)}}</span>
            </template>
          </el-table-column>
          <el-table-column
            width=""
            label="操作"
            prop="userName">
            <template slot-scope="scope">
              <el-button size="mini" type="primary"  @click="printCertFun(scope.$index, scope.row)">打印证书</el-button>
            </template>
          </el-table-column>
        </el-table>
        <div class="page-warp" style="position: absolute;bottom:0px;">
          <el-pagination
            @current-change="handleCurrentChange"
            :current-page.sync="pageNo"
            :page-size="pageSize"
            layout="prev, pager, next, jumper"
            :total="total">
          </el-pagination>
        </div>
    </div>
  </div>
</template>

<script>
import { queryAllProject, queryCertTypeByProjectId, pageQueryMemberTeamUserCert } from '@/api/association'
import UserHeaderNav from '@/components/common/UserCenter/UserHeaderNav'
import CopyRight from '@/components/common/CopyRight/CopyRight'
import {formatDate} from '@/components/common/config/formatTime.js'
// import md5 from 'js-md5'
// import QRCode from 'qrcodejs2'
export default {
  name: '',
  components: {
    UserHeaderNav,
    CopyRight
  },
  props: ['cartUserId'],
  data () {
    return {
      current: null,
      loading: false,
      type: this.$route.params.type,
      assoUserInfo: JSON.parse(localStorage.getItem('assoUserInfo')),
      titleMsg: '个人信息',
      title: '',
      options: [],
      keyWords: '',
      value: '',
      projectIds: [],
      projectIdVal: '',
      projectId: '',
      UserCerts: [],
      total: null,
      search: '',
      pageNo: 1,
      pageSize: 5,
      formLabelWidth: '80px',
      IdNum: '',
      certId: null,
      userId: '',
      certIdNum: '',
      typeId: '',
      memberUserId: '',
      cartLoading: false

    }
  },
  methods: {
    formatDate,
    resetTime (timerStr) {
      return timerStr.substring(0, timerStr.indexOf(' '))
    },
    printCertFun (index, row) {
      // this.showTable = true
      // this.getQueryAllProject()
      this.$router.push({path: '/PrintCert', query: {row: JSON.stringify(row)}})
    },
    // 根据id查询证书
    pageQueryMemberTeamUserCert () {
      console.log(this.assoUserInfo.memberId)
      this.cartLoading = true
      pageQueryMemberTeamUserCert({ memberId: this.assoUserInfo.memberId, pageNo: this.pageNo, pageSize: this.pageSize }, {projectId: this.projectId, typeId: this.typeId, userId: this.cartUserId, searchWords: this.keyWords}).then(res => {
        this.cartLoading = false
        if (res.data.status === 0) {
          this.UserCerts = res.data.data.list
          this.total = res.data.data.total
          console.log(res.data)
        } else {
          this.$message.warning(res.data.msg)
        }
      }).catch(() => {
        this.cartLoading = false
        this.$message.error('网络错误')
      })
    },

    // 查询协会下所有项目
    getQueryAllProject () {
      queryAllProject({ assoId: localStorage.getItem('assoId') }).then(res => {
        if (res.data.status === 0) {
          this.options = res.data.data
          console.log(res.data)
        }
      })
    },

    queryCertTypeByProjectId () {
      queryCertTypeByProjectId({ assoId: localStorage.getItem('assoId'), projectId: this.projectId }).then(res => {
        if (res.data.status === 0) {
          this.projectIds = res.data.data
          console.log(this.projectIds, '礼包')
        }
      })
    },
    selectOp (item) {
      this.projectIdVal = ''
      this.projectId = item
      console.log(this.projectId, 'projectId')
      this.queryCertTypeByProjectId()
    },
    selectType (item) {
      console.log(item)
      // debugger
      if (this.projectIds.length !== 0) {
        this.typeId = item
        console.log(this.typeId, 'typeId')
      }
    },
    handleCurrentChange: function (val) {
      this.pageQueryMemberTeamUserCert()
    },

    handleClose (done) {
      this.options = []
      this.projectId = ''
      this.typeId = ''
      this.keyWords = ''
    },
    handleDelete (index, row) {
      console.log(index, row)
    },
    init () {
      this.pageQueryMemberTeamUserCert()
      this.getQueryAllProject()
    }
  },
  mounted () { // 这里必须是mouted钩子
    // 下拉加载更多监听滚轮
    // window.addEventListener('scroll', this.handleScroll, true) // 监听（绑定）滚轮 滚动事件
  },
  created () {

    // this.getQueryAssoDesc()
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .manageCertificate{
    width: 100%;
    padding: 20px 20px;
  }
  .page-warp{
    position: absolute;
    bottom: 10px;
  }
  .seach-nav .el-input{
    width: 200px;
  }
  .el-dropdown-link {
    cursor: pointer;
    color: #409EFF;
  }
  .el-icon-arrow-down {
    font-size: 12px;
  }
</style>



// WEBPACK FOOTER //
// src/components/common/UserCenter/MemberCart.vue